// Detect if we're running on mobile/network access
const isNetworkAccess =
  window.location.hostname !== 'localhost' &&
  window.location.hostname !== '127.0.0.1';

// Detect if running in production (HTTPS)
const isProduction = window.location.protocol === 'https:';

const ROOT_API_URL =
  process.env.REACT_APP_ROOT_API_URL ||
  (isNetworkAccess
    ? `http://${window.location.hostname}:3001` // Use same hostname as frontend
    : 'http://localhost:3001'); // Default for localhost

const API_URL = `${ROOT_API_URL}`;

// WebSocket URL (use wss:// in production, ws:// in development)
const WEBSOCKET_URL =
  process.env.REACT_APP_WEBSOCKET_URL ||
  (isProduction
    ? `wss://${window.location.hostname}/ws` // Production: secure WebSocket
    : isNetworkAccess
      ? `ws://${window.location.hostname}:3001/ws` // Network access: use hostname
      : 'ws://localhost:3001/ws'); // Development: localhost

const HOME_URL = '/';
const SHOULD_ADD_DIACRITICS =
  process.env.REACT_APP_SHOULD_ADD_DIACRITICS === 'true';

export {
  API_URL,
  HOME_URL,
  ROOT_API_URL,
  WEBSOCKET_URL,
  SHOULD_ADD_DIACRITICS,
};
